<app-tabs>
  <a class="logo" routerLink="/"></a>
  <h5 routerLink="." i18n>
    Submit
    @if (selectedPlugin()) {
      <span>{{ selectedPlugin()!.name || selectedPlugin()!.tag }}</span>
    }
  </h5>
  <a routerLink="/submit"
     [class.current-tab]="store.submit.web() && !store.submit.genId()"
     [queryParams]="{ url: urlValue(), tag: store.submit.withoutGenId() }"
     [replaceUrl]="true"
     i18n-title title="🔗️ Link Post"
     queryParamsHandling="merge" i18n>link</a>
  <a routerLink="/submit/text"
     [class.current-tab]="store.submit.text()"
     [queryParams]="{ url: null, tag: store.submit.withoutGenId() }"
     i18n-title title="📝️ Text Post"
     queryParamsHandling="merge" i18n>text</a>
  <a routerLink="/submit/upload"
     [class.current-tab]="store.submit.upload()"
     [queryParams]="{ to: null, url: null }"
     i18n-title title="💾️ Upload"
     queryParamsHandling="merge" i18n>upload</a>
  @if (!admin.isWikiExternal()) {
    <a routerLink="/submit"
       [class.current-tab]="store.submit.wiki()"
       [queryParams]="{ url: wikify(), tag: store.submit.withoutGenId() }"
       [replaceUrl]="true"
       i18n-title title="📔️ Wiki Page"
       queryParamsHandling="merge" i18n>wiki</a>
  }
  @if (admin.getTemplate('dm')) {
    <a routerLink="/submit/dm"
       [class.current-tab]="store.submit.subpage() === 'dm' && !store.submit.dmPlugin()"
       [queryParams]="{ to: null, tag: null, url: null }"
       i18n-title title="📨️ Direct Message"
       queryParamsHandling="merge" i18n>dm</a>
  }
  @for (p of store.submit.submitGenId(); track p.tag) {
    @if (p.config?.submitDm) {
      <a routerLink="/submit/dm"
         [class.current-tab]="store.submit.subpage() === 'dm' && store.submit.to()[0] === p.tag"
         [queryParams]="{ to: p.tag, tag: null, url: null }"
         [replaceUrl]="true"
         [title]="p.name"
         queryParamsHandling="merge">{{ p.config!.submit }}</a>
    } @else if (p.config?.submitText) {
      <a routerLink="/submit/text"
         [class.current-tab]="store.submit.tags().includes(p.tag) && store.submit.url()"
         [queryParams]="{ tag: submitInternal(p.tag), url: genUrl }"
         [replaceUrl]="true"
         [title]="p.name"
         queryParamsHandling="merge">{{ p.config!.submit }}</a>
    } @else {
      <a routerLink="/submit/web"
         [class.current-tab]="store.submit.tags().includes(p.tag) && store.submit.url()"
         [queryParams]="{ tag: submitInternal(p.tag), url: genUrl }"
         [replaceUrl]="true"
         [title]="p.name"
         queryParamsHandling="merge">{{ p.config!.submit }}</a>
    }
  }
</app-tabs>
<router-outlet />

@if (!store.submit.subpage()) {
  <div class="full-page-form">
    <form class="form" [formGroup]="submitForm" (ngSubmit)="submit()">
      @if (!store.submit.wiki() && selectedPlugin()) {
        <span i18n>Type:</span>
        <div>
          <span>{{ selectedPlugin()!.name || selectedPlugin()!.tag }}</span>
          @if (selectedPlugin()!.config?.description) {
            <p class="description">
              {{ selectedPlugin()!.config!.description }}
            </p>
          }
        </div>
      }
      @if (store.submit.wiki()) {
        <span i18n>Type:</span>
        <div>
          <span i18n>Wiki</span>
          <p class="description" i18n>
            Create a text post that can be linked to via double bracket [[Wiki]] style.
          </p>
        </div>
      }

      @if (store.submit.wiki()) {
        <label for="url" class="big">Title:</label>
      } @else {
        <label for="url" class="big"></label>
      }
      <div class="form-array">
        @if (store.submit.web()) {
          <app-select-plugin [(plugin)]="plugin"
                             [settings]="!!admin.getPluginSettings(store.submit.tags()).length" />
        }
        @if (uploading()) {
          <progress class="grow" max="100" [value]="progress()"></progress>
        } @else {
          <datalist [id]="listId">
            @for (o of autocomplete(); track o.value) {
              <option [value]="o.value">{{ o.label }}</option>
            }
          </datalist>
          <input id="url"
                 [placeholder]="placeholder()"
                 class="big"
                 type="text"
                 size="1"
                 autocomplete="off"
                 [attr.list]="listId"
                 formControlName="url"
                 appAutofocus
                 (input)="search(url.value)"
                 (drop)="uploadFiles($event, $event.dataTransfer?.items)"
                 (paste)="uploadFiles($event, $event.clipboardData?.items) || getUrlPlugin()">
        }
        @if (!store.submit.wiki()) {
          @if ((!plugin() || plugin() === 'plugin/qr') && admin.getPlugin('plugin/qr')) {
            <app-qr-scanner [upload]="plugin() === 'plugin/qr'" (data)="scanQr($event)" />
          }
          @if (admin.getPlugin('plugin/file')) {
            @switch (plugin()) {
              @case (  'plugin/pdf') { <app-pdf-upload   (data)="onUpload($event)" /> }
              @case ('plugin/audio') { <app-audio-upload (data)="onUpload($event)" /> }
              @case ('plugin/video') { <app-video-upload (data)="onUpload($event)" /> }
              @case ('plugin/image') { <app-image-upload (data)="onUpload($event)" /> }
            }
          }
        }
      </div>

      @for (e of serverErrors(); track e) {
        <span><!-- Unexpected Error --></span>
        <div class="error">{{ e }}</div>
      }

      <span><!-- Tags --></span>
      <div class="tag-list form-array right">
        @for (p of store.submit.tags() | tagPreview:store.account.origin() | async; track p.tag) {
          <a class="tag" [routerLink]="['/tag', p.tag]">{{ p.name || '#' + p.tag }}</a>
        }
      </div>

      @if (!uploading()) {
        @if (existingRef()) {
          <br>
          <app-ref [ref]="existingRef()" [showToggle]="true" />
        }

        <br>
        <div class="validations">
          @for (v of validations(); track v.name) {
            @if (v.passed) {
              <div>✅️ &nbsp;{{ v.name }}</div>
            } @else {
              <div>❌️ &nbsp;{{ v.name }}</div>
            }
          }
        </div>

        <span><!-- Buttons --></span>
        <span class="buttons right floating">
          @if (submitFormPending()) {
            <app-loading [inline]="true" />
          }
          <button type="submit"
                  i18n-title title="Submit link"
                  i18n>@if (repost()) { Repost } @else { Next }</button>
        </span>

        @if (responsesToUrl().content.length > 0) {
          <span><!-- Title --></span>
          <span i18n>Existing Responses:</span>

          <span><!-- Existing responses --></span>
          <div class="list-container">
            @for (ref of responsesToUrl().content; track ref.url; let i = $index) {
              <div class="list-number">{{ i + 1 }}</div>
              <app-ref [ref]="ref" [showToggle]="true" />
            }
          </div>
          @if (responsesToUrl().page.totalPages > 1) {
            <span><!-- show more --></span>
            <a [routerLink]="['/ref', urlValue(), 'responses']"
               class="load-more no-select" i18n>
              see all
            </a>
          }
        }
      }
    </form>

    <span></span>
    <div class="summary-box" [class.hidden-without-removing]="!store.submit.refs().length">
      <h5 routerLink="./responses" i18n>Unsaved:</h5>
      <div class="list-container">
        @for (ref of store.submit.topRefs(); track ref.url; let i = $index) {
          <div class="list-number">{{ i + 1 }}</div>
          <app-ref [ref]="ref" [showToggle]="true" />
        }
      </div>
      @if (store.submit.refs().length > store.submit.topRefs().length) {
        <a routerLink="./submit/upload"
           queryParamsHandling="merge"
           class="load-more no-select" i18n>
          more unsaved
        </a>
      }
    </div>
  </div>
}
